export const getUserInitials = (user: {
  firstName: string;
  lastName: string;
}) => {
  return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`;
};
